export default __webpack_public_path__ + "static/060-df169fc2d4af5021a808354dd9f66d4d.jpg";